import { FC, ReactNode, useEffect } from 'react';
import LocationPickerStep from './location-picker-step/location-picker-step.component';
import PaymentsOnboardingStep from './payments-onboarding-step/payments-onboarding-step.component';
import { CreateFormStepsWrapper, CreateFormStepsWrapperProps, useCreateFormStepsStore } from './provider';
import UsageTermsStep from './usage-terms-step/usage-terms-step.component';

interface CreateFormStepsMainInternalProps {
  children: ReactNode;
  resetStateTrigger: boolean;
}

const CreateFormStepsMainInternal: FC<CreateFormStepsMainInternalProps> = ({ children, resetStateTrigger }) => {
  const { resetState } = useCreateFormStepsStore(['resetState']);

  // Reset the state when the resetStateTrigger changes.
  // This is useful when the modal is closed and reopened.
  useEffect(() => {
    if (resetStateTrigger) {
      resetState();
    }
  }, [resetStateTrigger, resetState]);

  return <>{children}</>;
};

interface CreateFormStepsMainProps extends CreateFormStepsWrapperProps, CreateFormStepsMainInternalProps {
  children: ReactNode;
}

const CreateFormStepsMain: FC<CreateFormStepsMainProps> = ({ children, resetStateTrigger, ...props }) => {
  return (
    <CreateFormStepsWrapper {...props}>
      <CreateFormStepsMainInternal resetStateTrigger={resetStateTrigger}>{children}</CreateFormStepsMainInternal>
    </CreateFormStepsWrapper>
  );
};

const CreateFormSteps = Object.assign(CreateFormStepsMain, {
  LocationPicker: LocationPickerStep,
  UsageTerms: UsageTermsStep,
  PaymentsOnboarding: PaymentsOnboardingStep,
});

export default CreateFormSteps;
